import { z } from "zod";

export const DocumentsSchema = z.object({
    file: z.any().refine((value) => value.length > 0, {
        message: "O documento é obrigatório!",
    }),
});
